import { Grid } from "@mui/material";
import CustomText from "../components/CustomText";

const TypeHospitalization = ({ TypeHospi }) => {
  return (
    <Grid container width="100%" mt={5}>
      <Grid size={design.Grid1} />
      <Grid container size={design.Grid10} justifyContent="center">
        {TypeHospi.map((doc, index) => {
          return (
            <Grid key={index} size={design.Grid6}>
              <CustomText
                variant="subtitle1"
                color={doc?.color}
                text={doc?.Title}
                sx={design.TextTitulo}
              >
                {doc?.Title}
              </CustomText>
              <CustomText
                variant="subtitle1"
                color="#333333"
                text={doc?.description}
                sx={design.Description}
              >
                {doc?.description}
              </CustomText>
            </Grid>
          );
        })}{" "}
      </Grid>
      <Grid size={design.Grid1} />
    </Grid>
  );
};
export default TypeHospitalization;
const design = {
  TextTitulo: {
    fontFamily: "Plus Jakarta Sans",
    fontSize: {
      xs: 25,
      sm: 25,
      md: 40,
      lg: 40,
    },
    fontWeight: 700,
    textAlign: "left",
  },
  Description: {
    fontFamily: "Plus Jakarta Sans",
    fontSize: {
      xs: 18,
      sm: 18,
      md: 20,
      lg: 20,
    },
    lineHeight: "normal",
    marginTop: "3%",
    marginBottom: "3%",
    textAlign: "left",
    paddingRight: 5,
  },
  Grid1: { xs: 1, md: 1, xl: 1, lg: 1 },
  Grid6: { xs: 12, md: 6, xl: 6, lg: 6 },
  Grid10: { xs: 10, md: 10, xl: 10, lg: 10 },
};
